import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_PRIORITY_TASK_MUTATION } from '../graphql/mutations'
import { DELETE_PRIORITY_TASK } from '../redux/action-types'

const useDeletePriorityTaskMutation = () => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    id =>
      apolloService.mutate({
        mutation: DELETE_PRIORITY_TASK_MUTATION,
        variables: { id },
        dispatch,
        action: DELETE_PRIORITY_TASK,
      }),
    [dispatch],
  )

  return [mutate]
}

export default useDeletePriorityTaskMutation
